import {
  WANTS_ANY_VALUE,
  getConditionColor,
  getLanguageCountryCode,
  getWantsConditionLabel,
  getWantsLanguageLabel
} from "../wantsSettingsOptions";

export function renderLanguageOption(value, anyLabel = "Any language") {
  if (value === WANTS_ANY_VALUE) {
    return <span className="account-setting-select-preview-label">{anyLabel}</span>;
  }

  const countryCode = getLanguageCountryCode(value);

  return (
    <>
      <span className={`fi fi-${countryCode} account-setting-select-preview-flag`} aria-hidden="true" />
      <span className="account-setting-select-preview-label">{getWantsLanguageLabel(value)}</span>
    </>
  );
}

export function renderConditionOption(value, anyLabel = "Any condition") {
  if (value === WANTS_ANY_VALUE) {
    return <span className="account-setting-select-preview-label">{anyLabel}</span>;
  }

  const conditionCode = String(value || "NM").toUpperCase();

  return (
    <>
      <span
        className="account-setting-select-preview-badge"
        style={{
          background: getConditionColor(conditionCode),
          color: conditionCode === "GD" ? "#111" : "#fff"
        }}
      >
        {conditionCode}
      </span>
      <span className="account-setting-select-preview-label">{getWantsConditionLabel(conditionCode)}</span>
    </>
  );
}

export function renderEditionOption(value, option, fallbackLabel = "") {
  const label = option?.label || fallbackLabel || String(value || "");

  if (!option?.showSetSymbol) {
    return <span className="account-setting-select-preview-label">{label}</span>;
  }

  const setCode = String(option?.setMetadata?.code || option?.setCode || "").toUpperCase();
  const symbolColor = option?.symbolColor || "#475569";

  return (
    <>
      {option?.setMetadata?.iconSvgMarkup ? (
        <span
          aria-hidden="true"
          style={{
            width: "16px",
            height: "16px",
            color: symbolColor,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "0 0 auto"
          }}
          dangerouslySetInnerHTML={{ __html: option.setMetadata.iconSvgMarkup }}
        />
      ) : setCode ? (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "28px",
            height: "20px",
            padding: "0 6px",
            borderRadius: "999px",
            background: "#f8fafc",
            border: "1px solid #dbe4f0",
            color: symbolColor,
            fontSize: "11px",
            fontWeight: 700,
            textTransform: "uppercase",
            flex: "0 0 auto"
          }}
        >
          {setCode}
        </span>
      ) : null}
      <span className="account-setting-select-preview-label">{label}</span>
    </>
  );
}

export function renderPlainOption(label) {
  return <span className="account-setting-select-preview-label">{label}</span>;
}